var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.company)?_c('CompanyWorkerList',{attrs:{"show-edit":true,"show-header":true,"show-add":true,"show-search":true,"company-id":_vm.company.id,"write-to-url":""}}):_vm._e(),(!_vm.company)?_c('v-card',[_c('v-card-text',[_vm._v(" Listeyi görüntülemek için üst menüden bir yönetim şirketi seçin. ")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }